import { CheckoutSession, getCheckoutSessionById } from '@nemuru-eng/js-api-client';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useUser } from '@/hooks/useUser';

export const CheckoutSessionPageTitle = () => {
  const {
    state: { loading: loadingPage, applicationParticipant },
    actions: pageActions,
  } = usePageContext();
  const { isUserAdmin } = useUser();
  const { getTextIdTranslation } = useTranslation();

  const { checkoutSessionId } = useParams();

  if (!checkoutSessionId) return null;

  const [customer, setCustomer] = useState<CheckoutSession['customer'] | null | undefined>(undefined);

  const { data: checkoutSession, loading: getCheckoutSessionByIdLoading } = useCache(
    getCheckoutSessionById,
    { checkoutSessionId },
    { fallbackData: null },
  );

  // Set Not Found
  useEffect(() => {
    if (checkoutSession === null && getCheckoutSessionByIdLoading === false) {
      pageActions.setNotFound(true);
    }
  }, [getCheckoutSessionByIdLoading]);

  // First setup of customer
  useLayoutEffect(() => {
    if (checkoutSession && customer === undefined) {
      setCustomer(checkoutSession.customer ?? null);
    }
  }, [checkoutSession]);

  // Set titles
  useLayoutEffect(() => {
    if (checkoutSession && customer !== undefined) {
      const firstName = customer?.fullName.firstName;
      const lastName = customer?.fullName.lastName;
      const fullName = `${firstName} ${lastName} `;

      if (isUserAdmin) {
        pageActions.setCustomTitle(firstName ? fullName : checkoutSession.id);
        checkoutSession && firstName && pageActions.setCustomSubtitle(applicationParticipant.role);
      } else {
        pageActions.setCustomTitle(firstName ? fullName : getTextIdTranslation('CHECKOUT_SESSION'));
      }
    }
  }, [customer, loadingPage]);

  return <></>;
};
